import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {
  ListConfiguredRepairCentresDto
} from "../../auto-generated-server-dtos/adjuster/configuration/list-configured-repair-centres-dto";

@Injectable({
  providedIn: 'root'
})
export class ListConfiguredRepairCentresService {

  constructor(private httpClient: HttpClient) { }

  listConfiguredRepairCentres() {
    return this.httpClient.get<ListConfiguredRepairCentresDto[]>(`${environment.apiServer}/Adjuster/Configuration/ListConfiguredRepairCentres`);
  }
}
